import { chartTabs, colorCharts, ColorChartVariants } from './ColorChart.data';

const useColorChart = (variant: ColorChartVariants) => {
  const { title, colors } = colorCharts[variant];
  return {
    chartTabs,
    title,
    colors,
  };
};

export type {
  ColorChartVariants,
  ColorModels,
  ColorChartItem,
} from './ColorChart.data';

export default useColorChart;
